import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Icon
} from '@material-ui/core';
import {
  Breadcrumb,
  BackdropCircular
} from 'components';
import RequestAccessForm from './RequestAccessForm';
import StoreAdminUsers from './StoreAdminUsers';


const formInfo = {
  name: 'Login Access Users',
  title: 'Login Access Users',
  tooltip: 'Enter names that will have access to eCommerce, Support and Merchant'
};

const RequestAccess = () => {
  const [isRequestAccess, setOpenRequestAccess] = useState(false);
  const {
    creatingCustomerAccount,
    loadingActiveStoreUsers
  } = useSelector((state) => state.user);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div className="mb-15">
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Users Access' }
          ]}
        />
        <div className="m-10">
          {isRequestAccess ?
            <RequestAccessForm
              formInfo={formInfo}
              setOpenRequestAccess={setOpenRequestAccess}
            />
            :
            <>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setOpenRequestAccess(true)}
              >
                <Icon className="mr-2">add</Icon>
                Request Users Access
              </Button>
              <StoreAdminUsers />
            </>
          }
        </div>
      </div>
      <BackdropCircular loading={creatingCustomerAccount || loadingActiveStoreUsers} />
    </div>
  );
};

export default RequestAccess;
